module.exports = __webpack_public_path__ + "img/kedu.1d124a19.png";